module.exports = __webpack_public_path__ + "img/pay-code.bd0afa08.png";